module.exports = __webpack_public_path__ + "static/img/resetpassword.c91fd16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/resetpassword.png
// module id = H10e
// module chunks = 5